export default [{"url":"https://qwqwawae-0.api.invexerp.io","name":"Branch 1","port":"5021","isStore":true,"isHQ":true}]